import { render, staticRenderFns } from "./CatalogCategoriesEdit.vue?vue&type=template&id=3f64f4aa&"
import script from "./CatalogCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./CatalogCategoriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports